export default "__VITE_ASSET__B228uE94__"